const call = (defaultTCode, defaultTCode2, defaultTitle, defaultTitle2, currentSearchTerm) => {
    return {
        storage: window.localStorage,

        loading: false,
        showRecent: false,
        searchTerm: currentSearchTerm,
        selectedTranslationCode: {open: false, title: defaultTitle, value: defaultTCode},
        selectedTranslationCode2: {open: false, title: defaultTitle2, value: defaultTCode2},

        async searchParallelBible(baseUrl) {
            window.location.href = `${baseUrl}?q=${this.searchTerm.replace(" ", "+").toLowerCase()}&t=${this.selectedTranslationCode.value}&t2=${this.selectedTranslationCode2.value}` //
        },
    };
};

export default call;